import { Button } from "@shadcn-in-nx/ui/button";
import { Input } from "@shadcn-in-nx/ui/input";
import { useTranslation } from "react-i18next";

function getPresetRange(preset) {
    const now = new Date();
    const until = now.toISOString().split("T")[0];
    if (preset === "7d") {
        const d = new Date(now);
        d.setDate(d.getDate() - 7);
        return { since: d.toISOString().split("T")[0], until };
    }
    if (preset === "30d") {
        const d = new Date(now);
        d.setDate(d.getDate() - 30);
        return { since: d.toISOString().split("T")[0], until };
    }
    // Current month
    const since = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-01`;
    return { since, until };
}

export default function DateRangeSelector({ since, until, onChange }) {
    const { t } = useTranslation();

    const applyPreset = (preset) => {
        onChange(getPresetRange(preset));
    };

    return (
        <div className="flex flex-wrap items-center gap-3">
            <div className="flex gap-2">
                <Button variant="outline" size="sm" onClick={() => applyPreset("7d")}>
                    {t("admin.facebookAudit.last7Days")}
                </Button>
                <Button variant="outline" size="sm" onClick={() => applyPreset("30d")}>
                    {t("admin.facebookAudit.last30Days")}
                </Button>
                <Button variant="outline" size="sm" onClick={() => applyPreset("month")}>
                    {t("admin.facebookAudit.thisMonth")}
                </Button>
            </div>
            <div className="flex items-center gap-2">
                <Input
                    type="date"
                    value={since}
                    onChange={(e) => onChange({ since: e.target.value, until })}
                    className="w-40"
                />
                <span className="text-muted-foreground text-sm">—</span>
                <Input
                    type="date"
                    value={until}
                    onChange={(e) => onChange({ since, until: e.target.value })}
                    className="w-40"
                />
            </div>
        </div>
    );
}
